// extracted by mini-css-extract-plugin
export default {"qrColor":"#362044","slideButton":"slide-button_slideButton__t+9tf","next":"slide-button_next__vwD2M","prev":"slide-button_prev__d-9M9"};